var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bce0fd;}.b{fill:#1a8cff;}.c{fill:#00429a;}.d{fill:#b9e1ff;}.e{fill:#ffddcf;}.f{fill:#fc6fd0;}.g{fill:#f5d0c7;}.h{fill:#ebc3ba;}.i{fill:#013272;}.j{fill:#ffcbbe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,42A41.961,41.961,0,1,0,41.961,0,41.985,41.985,0,0,0,0,42Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.155 4.342)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M19.243,0h43.2l-.181,72.264S40.5,83.736,20.385,73.033-.3,37.925-.3,37.925s-.5-12.2,4.381-21.68S19.243,0,19.243,0Z",
    transform: "translate(0.315 1.973)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.81 51.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M278.511,363.147a1.372,1.372,0,0,1-1.3-1.8,3.75,3.75,0,0,0,.175-.936,5.725,5.725,0,0,1-3.295,2.647,3.673,3.673,0,0,1-3.635-1.377c-2.264-2.5-.72-5.307.407-7.355,1.329-2.416,1.292-2.8.574-3.27a2.741,2.741,0,0,0-2.193.123c-4.378,1.614-10.356,8.246-10.857,9.966a1.372,1.372,0,1,1-2.634-.768c.817-2.8,7.583-9.944,12.542-11.772a5.024,5.024,0,0,1,4.646.158,3.477,3.477,0,0,1,1.678,3.656,10.689,10.689,0,0,1-1.354,3.23c-1.558,2.831-1.423,3.477-.777,4.192.574.635.9.562,1.013.539.824-.181,2.144-1.86,2.925-4.357a1.372,1.372,0,0,1,2.485-.3,9.457,9.457,0,0,1,1,2.538,21.193,21.193,0,0,0,1.062-2.5,1.372,1.372,0,0,1,2.112-.627c.627.47,2.684,2.178,2.843,4.427a4,4,0,0,1-1.279,3.181,1.372,1.372,0,0,1-1.94-1.94,1.288,1.288,0,0,0,.483-1.047,2.278,2.278,0,0,0-.437-1.071,8.166,8.166,0,0,1-3.661,4.33A1.37,1.37,0,0,1,278.511,363.147Z",
    transform: "translate(-255.695 -348.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M279.869,403.939H279.8a1.372,1.372,0,0,1-1.3-1.436c.073-1.536,2.324-4.379,2.775-4.933,1.342-1.651,3.329-3.671,5.179-3.92a1.372,1.372,0,0,1,.367,2.719c-.534.072-1.788.967-3.278,2.763a14.155,14.155,0,0,0-2.306,3.558A1.372,1.372,0,0,1,279.869,403.939Z",
    transform: "translate(-275.021 -386.7)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.292 11.89)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M170.191,67.81H129.264a1.375,1.375,0,0,1,0-2.743h40.926a1.375,1.375,0,0,1,0,2.743Z",
    transform: "translate(-127.981 -65.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M325.267,109.9H308.879a1.372,1.372,0,1,1,0-2.743h16.388a1.372,1.372,0,1,1,0,2.743Z",
    transform: "translate(-283.146 -100.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.508,109.9H129.353a1.372,1.372,0,0,1,0-2.743h23.155a1.372,1.372,0,1,1,0,2.743Z",
    transform: "translate(-127.981 -100.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M170.191,151.987H129.264a1.375,1.375,0,0,1,0-2.743h40.926a1.375,1.375,0,0,1,0,2.743Z",
    transform: "translate(-127.981 -136.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M360.866,194.075h-9.987a1.372,1.372,0,1,1,0-2.743h9.987a1.372,1.372,0,1,1,0,2.743Z",
    transform: "translate(-318.745 -172.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M158.909,194.075H129.353a1.372,1.372,0,0,1,0-2.743h29.556a1.372,1.372,0,0,1,0,2.743Z",
    transform: "translate(-127.981 -172.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.514,236.163H256.079a1.372,1.372,0,1,1,0-2.743h24.436a1.372,1.372,0,1,1,0,2.743Z",
    transform: "translate(-238.393 -207.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.644,236.163H129.354a1.372,1.372,0,1,1,0-2.743h15.291a1.372,1.372,0,1,1,0,2.743Z",
    transform: "translate(-127.982 -207.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M162.018,278.25H129.353a1.372,1.372,0,0,1,0-2.743h32.665a1.372,1.372,0,0,1,0,2.743Z",
    transform: "translate(-127.981 -243.434)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.009)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M206.261,202.027l-1.718,4.573a3.1,3.1,0,0,1-.966,1.363l-7.192,5.765-1.213-1.514a4.3,4.3,0,0,1-.945-2.684v-24.69h33.739a57.776,57.776,0,0,1,1.918,7.465,55.335,55.335,0,0,1,.723,7.574H210.77Z",
    transform: "translate(-175.771 -161.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M150.122,99.265v6.441H143.9v-3.478l.784.88a6.226,6.226,0,0,0,.517-8.789l0,0-1.3-1.471V59.01h6.226V99.265Z",
    transform: "translate(-131.665 -51.71)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M150.122,436.5l-3.113,9.339-2.544-7.643-.569-1.7Z",
    transform: "translate(-131.665 -382.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M68.16,215.607a6.226,6.226,0,0,1-.513,8.789l0,0-.784-.88v-.011L56.8,212.2l-.032-.043a3.124,3.124,0,0,1,.043-4.186l10.048-10.552v9.049L63.3,210.133l3.564,4Z",
    transform: "translate(-54.63 -173.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M57.253,331.711l.569,1.7a6.67,6.67,0,0,1-1.138,1.342L45.81,322.512a3.114,3.114,0,0,1,.043-4.186l1.342-1.406,10.058,11.3v3.489Z",
    transform: "translate(-45.022 -277.716)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M161.457,8.373A1.074,1.074,0,0,1,160.384,7.3V1.073a1.073,1.073,0,1,1,2.147,0V7.3A1.074,1.074,0,0,1,161.457,8.373Z",
    transform: "translate(-152.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M98.542,86.985a1.074,1.074,0,0,1-1.073-1.073v-7.2a3.214,3.214,0,0,1,3.21-3.21h2.533a1.073,1.073,0,1,1,0,2.147h-2.533a1.064,1.064,0,0,0-1.063,1.063v7.2A1.074,1.074,0,0,1,98.542,86.985Z",
    transform: "translate(-97.469 -66.16)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M187.944,293.37l-1.213-1.514a5.357,5.357,0,0,1,.818-7.528l2.946-2.362,2.56-7.006,2.016.736-2.662,7.289a1.087,1.087,0,0,1-.337.47L188.894,286a3.211,3.211,0,0,0-.487,4.513,0,0,0,0,0,0,0l.537.674,5.655-3.008C194.882,287.953,187.944,293.37,187.944,293.37Z",
    transform: "translate(-168.167 -240.948)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIcon);
export default __webpack_public_path__ + "static/media/sign-icon.8f1cde394f9dfbb0697cb39f5df26b62.svg";
export { ForwardRef as ReactComponent };